import { USERNAME } from 'mk2/helpers/api';

export const wall = '/wall/';
export const wallMentions = `/wall/${USERNAME}/`;
